import { render, staticRenderFns } from "./UpdatePersonalDataWarningPopup.vue?vue&type=template&id=47ca4cfa&scoped=true&"
import script from "./UpdatePersonalDataWarningPopup.vue?vue&type=script&lang=js&"
export * from "./UpdatePersonalDataWarningPopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePersonalDataWarningPopup.vue?vue&type=style&index=0&id=47ca4cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca4cfa",
  null
  
)

export default component.exports